import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const vatFeeEndpoint = ENDPOINTS.VATFEE;

// Category API
export const vatFeeApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["vatFees"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getVatFees: builder.query({
        query: (payload) => `${vatFeeEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "vatFees" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      addVatFee: builder.mutation({
        query: (requestData) => ({
          url: `${vatFeeEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "vatFees" }],
      }),
      updateVatFee: builder.mutation({
        query: ({id, requestData}) => ({
          url: `${vatFeeEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "vatFees" }],
      }),
      deleteVatFee: builder.mutation({
        query: (id) => ({
          url: `${vatFeeEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "vatFees" }],
      }),
    }),
  });

// Export hooks for usage in components

export const { useGetVatFeesQuery, useAddVatFeeMutation, useDeleteVatFeeMutation, useUpdateVatFeeMutation } = vatFeeApi;
